import { IS_PHONE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { PreOverquotaModalProps } from './PreOverquotaModal.types';

export const renderPreOverquotaModal = (data: PreOverquotaModalProps) =>
    openPopupHelper({
        popupName: IS_PHONE_BROWSER ? popupNames.PRE_OVERQUOTA_MODAL_MOBILE : popupNames.PRE_OVERQUOTA_MODAL,
        data,
    });
